import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactCalendar from 'react-calendar/dist/entry.nostyle';
import { FormattedDate } from 'react-intl';

import Button from '../../button/Button';
import Icon from '../../icon/Icon';
import P from '../../containers/Paragraph';
import { dateWithoutTimezone } from '../../../util/dateWithoutTimezone';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      showCalendar: false
    };
  }

  componentDidMount() {
    const { value, endDate } = this.props;
    document.addEventListener('mousedown', this.handleClickOutside);
    this.formatDate(value || endDate);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setCalendarRef = node => (this.calendarRef = node);

  setShowCalendar = () => this.setState(prevState => ({ showCalendar: !prevState.showCalendar }));

  formatDateShort = value => {
    const dateString = `${value}`;
    return dateString.substring(0, 1);
  };

  formatDate = async dateString => {
    if (this.validDate(dateString)) {
      const date = new Date(dateString);
      const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

      await this.setState({ date: `${date.getFullYear()}-${month}-${day}` });
    }
  };

  updateDate = value => this.setState({ date: value });

  // eslint-disable-next-line
  validDate = date => date instanceof Date && isFinite(date || new Date());

  handleClickOutside = event => {
    const { showCalendar } = this.state;
    if (!this.calendarRef.contains(event.target) && showCalendar) {
      this.setShowCalendar();
    }
  };

  handleChange = async e => {
    const { isStart, onChange } = this.props;
    await this.formatDate(e);

    const { date } = this.state;
    onChange(date, isStart);
    this.setShowCalendar();
  };

  render() {
    const { buttonLabel, endDate, startDate, value, isStart } = this.props;
    const { showCalendar } = this.state;

    return (
      <>
        <span className='hidden' data-desc='calendar__input_isStart'>
          {isStart.toString()}
        </span>
        <span className='hidden' data-desc='calendar__input_date'>
          {value}
        </span>
        <Button
          useBareClass
          className='calendar__trigger p4-sm ml10-sm mr10-sm m0-lg'
          onClick={this.setShowCalendar}
          secondary
          data-desc='calendar__button'
        >
          <P className='d-sm-ib mr2-sm' data-desc='calendar__button_label'>
            {buttonLabel}
          </P>
          <Icon name='calendar' alt='calendar' />
        </Button>
        <div ref={this.setCalendarRef} style={{ position: 'relative' }}>
          {showCalendar && (
            <div className='calendar__containerOuter'>
              <div className='m2-sm border-bottom-black'>
                <div className='body-4 text-color-secondary' data-desc='calendar__input_label'>
                  <TranslatedCopy id={`calendar.label.${isStart ? 'from' : 'to'}`} />
                </div>
                <div
                  className='flex-container row space-between align-center'
                  data-desc='calendar__input_dateFormatted'
                >
                  <FormattedDate
                    value={dateWithoutTimezone(value || endDate)}
                    year='2-digit'
                    month='numeric'
                    day='numeric'
                  />
                  <Icon name='calendar' alt='calendar' className='mr3-sm mb2-sm' />
                </div>
              </div>
              {this.validDate && (
                <ReactCalendar
                  className='react-calendar'
                  value={dateWithoutTimezone(value)}
                  calendarType='US'
                  maxDate={endDate}
                  minDate={startDate}
                  formatShortWeekday={value => this.formatDateShort(value)}
                  next2Label=''
                  prev2Label=''
                  minDetail='month'
                  prevLabel={<Icon name='chevron-left-cell' alt='left arrow' isLight />}
                  nextLabel={<Icon name='chevron-right-cell' alt='right arrow' isLight />}
                  onChange={this.handleChange}
                />
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

Calendar.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isStart: PropTypes.bool
};

Calendar.defaultProps = {
  value: '',
  isStart: false
};

export default Calendar;
